import * as React from "react"
import Section from "../../../../core/layout/main/section/Section"
import Button from "../../../common/blocks/button/Button"
import Container from "../../../../core/layout/main/container/Container"

const TestComp2Section = ({ buttonText }) => {
  return (
    <Section>
      <Container>
        <p>Ceci est un exemple de texte.</p>
        <Button to="/test-1234"> {buttonText} </Button>
      </Container>
    </Section>
  )
}

export const name = "TestComp2Section"

export const init = (componentData, pageContext) => (
  <TestComp2Section key={componentData.id} buttonText={componentData.label2} />
)

export default TestComp2Section
